module.exports = __webpack_public_path__ + "static/media/right-menu-vip-icon.5aece720.svg";